
import { CoverSection } from '../components/wiperBladesPage/coverSection/CoverSection';
import { MainSection } from '../components/wiperBladesPage/mainSection/MainSection';

export function WiperBladesPage() {
  return (
    <>
      <CoverSection />
      <MainSection />
    </>
  );
}
